import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-automatic-save-dialog',
  templateUrl: './automatic-save-dialog.component.html',
  styleUrls: ['./automatic-save-dialog.component.scss']
})
export class AutomaticSaveDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AutomaticSaveDialogComponent>) { }

  ngOnInit() {
  }

}
